var _rect, _rect2, _line, _line2, _line3, _line4, _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFq45(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.548047,
    y: 0.796094,
    width: 48.972,
    height: 48.972,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11.7844,
    y: 12.0305,
    width: 26.4993,
    height: 26.4993,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 38.3719,
    y1: 12.1824,
    x2: 49.6082,
    y2: 0.946085,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 0.698024,
    y1: 49.8543,
    x2: 11.9343,
    y2: 38.618,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 38.134,
    y1: 38.6199,
    x2: 49.3703,
    y2: 49.8562,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 0.460179,
    y1: 0.944118,
    x2: 11.6965,
    y2: 12.1804,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.476 27.62V26.878L21.572 20.018H22.734V26.766H24.232V27.62H22.734V30H21.768V27.62H16.476ZM21.81 21.096L17.61 26.766H21.81V21.096ZM31.8239 20.802H26.6999V24.386C26.9333 24.0593 27.2739 23.7933 27.7219 23.588C28.1699 23.3733 28.6553 23.266 29.1779 23.266C29.9433 23.266 30.5686 23.4247 31.0539 23.742C31.5393 24.05 31.8893 24.456 32.1039 24.96C32.3186 25.4547 32.4259 25.9867 32.4259 26.556C32.4259 27.2093 32.2999 27.802 32.0479 28.334C31.8053 28.8567 31.4273 29.272 30.9139 29.58C30.4099 29.888 29.7799 30.042 29.0239 30.042C28.0626 30.042 27.2833 29.7947 26.6859 29.3C26.0886 28.796 25.7246 28.1193 25.5939 27.27H26.5599C26.6813 27.886 26.9613 28.362 27.3999 28.698C27.8386 29.034 28.3799 29.202 29.0239 29.202C29.8359 29.202 30.4473 28.964 30.8579 28.488C31.2779 28.0027 31.4879 27.3633 31.4879 26.57C31.4879 25.7953 31.2779 25.1933 30.8579 24.764C30.4379 24.3253 29.8359 24.106 29.0519 24.106C28.5106 24.106 28.0346 24.232 27.6239 24.484C27.2133 24.736 26.9099 25.0767 26.7139 25.506H25.7899V19.948H31.8239V20.802Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFq45);
export default __webpack_public_path__ + "static/media/fq45.97800846d82434d5ad45ee54df28d274.svg";
export { ForwardRef as ReactComponent };